import { createSlice } from '@reduxjs/toolkit';

export const vendorsSlice = createSlice({
  name: 'vendors',
  initialState: {
    vendors: [],
    currentVendor: {
      id: 0,
      name: '',
      pais: '0',
      identificacion: '',
      atributos: [],
    },
    vendorAttributes: [],
    currentVendorAttribute: {
      id: 0,
      name: '',
      value: '',
    },
    attributes: [],
  },
  reducers: {
    setVendors: (state, action) => {
      state.vendors = action.payload;
    },
    addVendor: (state, action) => {
      state.vendors.push(action.payload);
    },
    deleteVendor: (state, action) => {
      state.vendors = state.vendors.filter((vendor) => vendor.id !== action.payload);
    },
    updateVendor: (state, action) => {
      state.vendors = state.vendors.map((vendor) => (vendor.id === action.payload.id ? action.payload : vendor));
    },
    viewVendor: (state, action) => {
      state.currentVendor = action.payload;
    },
    resetCurrentVendor: (state) => {
      state.currentVendor = {
        id: 0,
        name: '',
        pais: '',
        identificacion: '',
        atributos: [],
      };
    },
    setId: (state, action) => {
      state.currentVendor.id = action.payload;
    },
    addVendorAttribute: (state, action) => {
      let attribute = {
        id: action.payload.id,
        name: action.payload.name,
        value: action.payload.value,
      };
      if (attribute.id === 0) {
        // get max id from current attributes
        let maxId = 0;
        state.vendorAttributes.forEach((attr) => {
          if (attr.id > maxId) {
            maxId = attr.id;
          }
        });
        state.attributes.forEach((attr) => {
          if (attr.id > maxId) {
            maxId = attr.id;
          }
        });
        attribute.id = maxId + 1;
      }
      state.vendorAttributes.push(attribute);
    },
    deleteVendorAttribute: (state, action) => {
      state.vendorAttributes = state.vendorAttributes.filter((attribute) => attribute.id !== action.payload);
    },
    viewVendorAttribute: (state, action) => {
      state.currentVendorAttribute = action.payload;
    },
    setAttributes: (state, action) => {
      state.attributes = action.payload;
    },
    resetCurrentVendorAttributes: (state) => {
      state.vendorAttributes = [];
    },
    setVendorsAttributes: (state, action) => {
      state.vendorAttributes = action.payload;
    },
  },
});

export const {
  setVendors,
  addVendor,
  deleteVendor,
  updateVendor,
  viewVendor,
  resetCurrentVendor,
  setId,
  addVendorAttribute,
  deleteVendorAttribute,
  updateVendorAttribute,
  viewVendorAttribute,
  attributes,
  setAttributes,
  resetCurrentVendorAttributes,
  setVendorsAttributes,
} = vendorsSlice.actions;

export const selectVendors = (state) => state.vendors.vendors;
export const selectCurrentVendor = (state) => state.vendors.currentVendor;

export default vendorsSlice.reducer;
